"use client";

import { getCookies } from "@/utils/common/cookiesHelper/CookiesUtills";
import {
  getLocalStorageItem,
  removeItem,
} from "@/utils/common/localStorageItemHelper/localStorageItemUtills";
import { getFlightDestinationHistories } from "@/utils/common/other/ga4Utills";
import { toLowerCaseString } from "@/utils/common/textHelper/stringConvertFormatUtills";
import { CookiesItemEnum } from "@/utils/enums/CookiesItemEnum";
import { LocalStorageItemEnum } from "@/utils/enums/LocalStorageItemEnum";

import type {
  ClickArticleItem,
  ClickDestinationItemOnSeoSection,
  ClickMenuOnSerchSection,
  ClickPopularDestination,
  ClickPopularSearchItem,
  ClickPromotionItem,
  ClickRecentlySearchItem,
  ClickRecommendSearchItem,
  ClickSearchButtonFlight,
  ClickSearchButtonHotel,
  SeenPromotionItem,
} from "../interface/homePageInterface";

const pushGAHomePage = () => {
  const { dataLayer } = window as any;
  try {
    const ClickRecentlySearchItem = (
      displayName: string,
      cityName: string,
      typeSelected: "click_recent_search",
      slug: string,
    ) => {
      if (dataLayer !== undefined) {
        let eventLabel = (slug as string).replace(/\s+/g, "-");
        if (displayName.includes("(") === true) {
          eventLabel =
            `${toLowerCaseString((cityName || "").replace(/\s+/g, "-"))}_${(
              slug as string
            ).replace(/\s+/g, "-")}` || "";
        }
        const paramGa: ClickRecentlySearchItem = {
          event: `flight_search`,
          event_action: typeSelected,
          event_label: eventLabel || "",
        };
        dataLayer.push(paramGa);
      }
    };

    const ClickRecommendSearchItem = (
      displayName: string,
      cityName: string,
      typeSelected: "click_search_suggestion",
      slug: string,
    ) => {
      if (dataLayer !== undefined) {
        let eventLabel = (slug as string).replace(/\s+/g, "-");
        if (displayName.includes("(") === true) {
          eventLabel =
            `${toLowerCaseString((cityName || "").replace(/\s+/g, "-"))}_${(
              slug as string
            ).replace(/\s+/g, "-")}` || "";
        }
        const paramGa: ClickRecommendSearchItem = {
          event: `flight_search`,
          event_action: typeSelected,
          event_label: eventLabel || "",
        };
        dataLayer.push(paramGa);
      }
    };
    // ยังทำไม่ได้ยังไม่มี
    const ClickPopularSearchItem = (param: ClickPopularSearchItem) => {
      if (dataLayer !== undefined) {
        dataLayer.push(param);
      }
    };

    const ClickSearchButtonFlight = (
      event: string,
      eventAction: string,
      bookingType: string,
      departure: string,
      arrival: string,
      arrivalDate: string,
      departureDate: string,
      duration: string,
      bookingClass: string,
      numberOfAdults: number,
      numberOfKids: number,
      numberOfInfant: number,
    ) => {
      const inputCollect = JSON.parse(
        getLocalStorageItem(LocalStorageItemEnum.FLIGHT_SEARCH_BAR) || "{}",
      );
      const keyInputCollectDepart =
        getLocalStorageItem(LocalStorageItemEnum.GOTHER_SEARCH_BAR) || "";
      const keyInputCollectArrival =
        getLocalStorageItem(LocalStorageItemEnum.GOTHER_SEARCH_BAR2) || "";
      const isFlightSwitch =
        getLocalStorageItem(LocalStorageItemEnum.IS_FLIGHT_SWITCH) ?? "";

      let searchResult = "";
      let searchTxt = "";

      searchResult = `${inputCollect.firstInput}|${inputCollect.secondInput}`;
      if (isFlightSwitch === "unSwitch" || isFlightSwitch === "") {
        searchTxt = `${keyInputCollectDepart}|${keyInputCollectArrival}`;
      } else {
        searchTxt = `${keyInputCollectArrival}|${keyInputCollectDepart}`;
      }

      if (dataLayer !== undefined) {
        const flightType = getFlightDestinationHistories();
        const gaParam: ClickSearchButtonFlight = {
          event,
          event_action: eventAction,
          booking_type: `${bookingType}${flightType ? `-${flightType}` : ""}`,
          departure,
          arrival,
          arrival_date: arrivalDate,
          departure_date: departureDate,
          duration,
          booking_class: bookingClass,
          number_of_adults: numberOfAdults,
          number_of_kids: numberOfKids,
          number_of_babies: numberOfInfant,
          search_result: `${searchResult}`,
          event_label: searchTxt,
        };
        dataLayer.push(gaParam);
        removeItem(LocalStorageItemEnum.FLIGHT_SEARCH_BAR);
        removeItem(LocalStorageItemEnum.IS_FLIGHT_SWITCH);
        removeItem(LocalStorageItemEnum.GOTHER_SEARCH_BAR);
        removeItem(LocalStorageItemEnum.GOTHER_SEARCH_BAR2);
      }
    };
    const ClickSearchButtonHotel = (param: ClickSearchButtonHotel) => {
      if (dataLayer !== undefined) {
        dataLayer.push(param);
      }
    };
    const ClickPopularDestination = (eventLabel: string) => {
      if (dataLayer !== undefined) {
        const gaParam: ClickPopularDestination = {
          event: "homepage",
          event_action: "click_destination",
          event_label: eventLabel,
        };
        dataLayer.push(gaParam);
      }
    };
    const SeenPromotionItem = (
      id: string,
      promotionName: string,
      creativeName: string,
    ) => {
      if (dataLayer !== undefined) {
        const gaParam: SeenPromotionItem = {
          event: "view_promotion",
          ecommerce: {
            items: [
              {
                promotion_id: id,
                promotion_name: promotionName,
                creative_name: creativeName,
              },
            ],
          },
        };
        dataLayer.push(gaParam);
      }
    };
    const ClickPromotionItem = (
      id: string,
      promotionName: string,
      creativeName: string,
    ) => {
      if (dataLayer !== undefined) {
        const gaParam: ClickPromotionItem = {
          event: "select_promotion",
          ecommerce: {
            items: [
              {
                promotion_id: id,
                promotion_name: promotionName,
                creative_name: creativeName,
              },
            ],
          },
        };
        dataLayer.push(gaParam);
      }
    };
    const ClickArticleItem = (url: string) => {
      if (dataLayer !== undefined) {
        const gaParam: ClickArticleItem = {
          event: `homepage`,
          event_action: "click_article",
          event_label: url,
        };
        dataLayer.push(gaParam);
      }
    };
    const ClickDestinationItemOnSeoSection = (eventLabel: string) => {
      if (dataLayer !== undefined) {
        const gaParam: ClickDestinationItemOnSeoSection = {
          event: `homepage`,
          event_action: "click_flight",
          event_label: eventLabel,
        };
        dataLayer.push(gaParam);
      }
    };

    const ClickMenuOnSerchSection = (key: string) => {
      if (dataLayer !== undefined) {
        let eventLabel;

        switch (key) {
          case "flights":
            eventLabel = "flight";
            break;

          case "hotels":
            eventLabel = "hotel";
            break;

          case "tour-packages":
            eventLabel = "tour";
            break;

          case "car-rentals":
            eventLabel = "carrental";
            break;

          case "klub":
            eventLabel = "klub";
            break;

          default:
            eventLabel = "experiences";
            break;
        }

        const gaParam: ClickMenuOnSerchSection = {
          event: "search_section",
          event_action: "click_search_section",
          event_label: eventLabel,
        };

        dataLayer.push(gaParam);
      }
    };

    return {
      ClickRecentlySearchItem,
      ClickRecommendSearchItem,
      ClickPopularSearchItem,
      ClickSearchButtonFlight,
      ClickSearchButtonHotel,
      ClickPopularDestination,
      SeenPromotionItem,
      ClickPromotionItem,
      ClickArticleItem,
      ClickDestinationItemOnSeoSection,
      ClickMenuOnSerchSection,
    };
  } catch (error) {
    const ga4ShowError = getCookies(CookiesItemEnum.GA4_DISPLAY_MODE_COOKIES);
    if (ga4ShowError === "true") {
      throw new Error();
    }
    return null;
  }
};

export default pushGAHomePage;
